<template>
  <div class="porderxz">
    <div class="sershop between">
      <div class="left">
        <img src="../../../assets/contmodeldet/daxdcover_sample.png" alt="" />
      </div>
      <div class="right">
        <div class="title">合同代写服务-婚前协议</div>
        <div class="info">
          <div class="infoitem flex_start">
            <div class="label">线下律所价</div>
            <div class="oldpri between">
              <div class="pr">¥599-1099</div>
              <div class="xd"><span>11111</span>人下单</div>
            </div>
          </div>

          <div class="infoitem flex_start">
            <div class="label">我们的报价</div>
            <div class="labprice">¥149.0</div>
          </div>

          <div class="infoitem flex_start">
            <div class="label">赠送服务</div>
            <div class="zenser flex_start">
              <img src="../../../assets/contmodeldet/zeng_img.png" alt="" />
              下单后3日内律师免费答疑服务
            </div>
          </div>

          <div class="infoitem flex_start">
            <div class="label">服务内容</div>
            <div class="sercont">
              定制《婚前协议》+ 3日内律师<span>免费答疑</span>服务
            </div>
          </div>
        </div>
        <div class="guarantee flex_start">
          <img src="../../../assets/contmodeldet/ceno_img.png" alt="" />
          <span> 服务保障：3天内不限次修改，满意为止 </span>
        </div>
        <div class="guarantee flex_start">
          <img src="../../../assets/contmodeldet/bz_img.png" alt="" />
          <span
            >服务承诺：我们承诺您即将使用的代写服务提供商均为在中国大陆取得合法律师执业证书的专业律师
          </span>
        </div>
        <div class="btnlist flex_start">
          <div class="btn submit">立即购买</div>
          <div class="btn collect">收藏</div>
        </div>
      </div>
    </div>
    <div class="serinfo mt50">
      <sec-title
        class="text_center"
        Text="婚内财产协议代写服务介绍"
        desc-text="为您省心、放心、安心"
      />
      <div class="sercont between">
        <div class="list">
          <div class="item flex_start">
            <div class="taglab">服务类型</div>
            <div class="tagcont">
              1. 根据您的需求一对一定制合同 2. 三个工作日内不限次修改，满意为止
              3. 三个工 作日内不限次答疑
            </div>
          </div>
          <div class="item flex_start">
            <div class="taglab">服务说明</div>
            <div class="tagcont">
              下单付款后，律师将在5-10分钟内主动与您沟通需求
            </div>
          </div>
          <div class="item flex_start">
            <div class="taglab">售后服务</div>
            <div class="tagcont">
              1. 尊享3日内不限次修改和免费答疑服务 2.
              全程服务保障，不满意可申请退款
            </div>
          </div>
          <div class="item flex_start">
            <div class="taglab">服务时间</div>
            <div class="tagcont">
              正常工作日下单，5分钟内响应；节假日下单，顺延至下一工作日开始起草
            </div>
          </div>
        </div>
        <div class="listpt">
          <img src="../../../assets/contmodeldet/daxdinfo_sample.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>

<style lang="scss" scoped>
.porderxz {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .sershop {
    align-items: flex-start;
    .left {
      width: 390px;
      img {
        width: 390px;
        height: 390px;
      }
    }
    .right {
      width: 750px;
      .title {
        font-size: 26px;
        color: #333333;
      }
      .info {
        margin-top: 24px;
        width: 100%;
        padding: 1px 22px 20px;
        background: #f8f8f8;
        font-size: 14px;
        color: #666666;
        .infoitem {
          margin-top: 22px;
          line-height: 16px;
          .label {
            width: 120px;
            text-align: left;
          }
          .oldpri {
            flex: 1;
            .pr {
              font-size: 14px;
              text-decoration: line-through;
              color: #333333;
            }
            .xd {
              span {
                font-size: 16px;
                color: #e80000;
              }
            }
          }
          .labprice {
            font-size: 22px;
            color: #ea130f;
          }
          .zenser {
            img {
              width: 18px;
              height: 18px;
              margin-right: 6px;
            }
          }
          .sercont {
            color: #333333;
            span {
              color: #0465ea;
              cursor: pointer;
            }
          }
        }
      }
      .guarantee {
        img {
          margin-right: 10px;
        }
        margin-top: 22px;
        font-size: 14px;
        color: #999999;
      }
      .btnlist {
        margin-top: 20px;
        .btn {
          cursor: pointer;
          width: 154px;
          height: 42px;
          line-height: 42px;
          text-align: center;
          font-size: 18px;
          &.submit {
            background: #f25619;
            color: #ffffff;
          }
          &.collect {
            margin-left: 26px;
            background: #afafaf;
            color: #ffffff;
          }
        }
      }
    }
  }
  .sercont {
    align-items: flex-start;
    .list {
      .item {
        align-items: flex-start;
        margin-bottom: 42px;
        &:last-child {
          margin-bottom: 0;
        }
        width: 840px;
        font-size: 18px;
        color: #333333;
        line-height: 30px;
        .taglab {
          margin-right: 30px;
          width: 130px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #3e83f4;
          border-radius: 20px;
          color: #f0f6ff;
        }
        .tagcont {
          width: 680px;
        }
      }
    }
    .listpt {
      img {
        width: 328px;
        height: 306px;
      }
    }
  }
}
</style>
